// extracted by mini-css-extract-plugin
export default {"container":"style_container__Ib-k2","img":"style_img__PRB5q","info":"style_info__9OERs","text":"style_text__8UFkm"};